import React, { useState } from 'react';
import './components/SongList.css'; 

const ResetPassword = () => {
  // Grab token from URL path
  const pathParts = window.location.pathname.split('/');
  const token = pathParts[pathParts.length - 1];

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [msg, setMsg] = useState("");
  const [success, setSuccess] = useState(false);

  // --- DYNAMIC URL ---
  const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) return setMsg("Passwords do not match");

    try {
      // Use dynamic BASE_URL here
      const res = await fetch(`${BASE_URL}/api/reset-password/${token}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password })
      });
      const data = await res.json();
      if (res.ok) {
        setSuccess(true);
        setMsg("Password updated! You can now log in.");
      } else {
        setMsg(data.message);
      }
    } catch (err) { console.error(err); }
  };

  if (success) {
    return (
      <div className="login-wrapper">
        <div className="login-card" style={{textAlign:'center'}}>
          <h2>Success!</h2>
          <p>Your password has been reset.</p>
          <a href="/" className="btn-create-large" style={{display:'inline-block', marginTop:'20px', textDecoration:'none'}}>Go to Login</a>
        </div>
      </div>
    );
  }

  return (
    <div className="login-wrapper">
      <div className="login-card">
        <h2 className="login-title">New Password</h2>
        {msg && <div className="error-msg">{msg}</div>}
        <form onSubmit={handleSubmit} className="login-form">
          <input 
            type="password" 
            placeholder="New Password" 
            className="tool-input"
            value={password} onChange={e=>setPassword(e.target.value)}
            required
          />
           <input 
            type="password" 
            placeholder="Confirm Password" 
            className="tool-input"
            value={confirm} onChange={e=>setConfirm(e.target.value)}
            required
          />
          <button type="submit" className="btn-create-large" style={{width:'100%', borderRadius:'8px'}}>Update Password</button>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;